/**
 * Blossom — footer.js
 * <footer-accordion> — footer menu columns are always open on tablet/desktop
 * and collapse into accordions on mobile. Without JavaScript the <details>
 * stays open (the markup ships with `open`), so links are always reachable.
 */
(() => {
  if (customElements.get('footer-accordion')) return;

  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.details?.querySelector('summary');
      if (!this.details || !this.summary || this.bound) return;
      this.bound = true;

      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.onChange = () => this.update();
      this.onSummaryClick = (event) => {
        if (this.mediaQuery.matches) event.preventDefault();
      };

      this.summary.addEventListener('click', this.onSummaryClick);
      this.mediaQuery.addEventListener('change', this.onChange);
      this.update(true);
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.onChange);
    }

    update(initial = false) {
      const desktop = this.mediaQuery.matches;
      this.classList.toggle('is-static', desktop);
      if (desktop) {
        this.details.open = true;
        this.summary.setAttribute('tabindex', '-1');
      } else {
        this.summary.removeAttribute('tabindex');
        // Collapse when entering mobile (keep editor selections visible).
        if (initial || !this.contains(document.activeElement)) this.details.open = false;
      }
    }
  }

  customElements.define('footer-accordion', FooterAccordion);

  // Theme editor: expand a menu when its block is selected on mobile previews.
  document.addEventListener('shopify:block:select', (event) => {
    const accordion = event.target.closest?.('footer-accordion');
    if (accordion) accordion.querySelector('details').open = true;
  });
})();
